module.exports = __webpack_public_path__ + "static/media/Afaq_9001_g.575df793.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Afaq_9001_g.png
// module id = 1736
// module chunks = 0